import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ConditionAssessmentService {
  public getConditionRatingComponents() {
    return [
      {
        label: 'A',
        key: 'a',
        name: 'Columns, Walls and Notional Boundaries',
        description: 'Including internal and external structural and non structural elements, demising walls and any notional boundaries.'
      },
      {
        label: 'B',
        key: 'b',
        name: 'Vertical Penetrations areas',
        description: 'Including all vertical circulation and technical areas (staircase openings, lifts, escalators and other service shafts)'
      },
      {
        label: 'C',
        key: 'c',
        name: 'Technical areas',
        description: 'Technical areas including mechanical and electrical plant rooms and other maintenance rooms'
      },
      {
        label: 'D',
        key: 'd',
        name: 'Sanitary areas',
        description: "Sanitary areas including toilet facilities, cleaners'/janitors' cupboards, bath/shower rooms and changing rooms."
      },
      {
        label: 'E',
        key: 'e',
        name: 'Circulation areas',
        description: 'All circulation areas enclosed or not.'
      },
      {
        label: 'F',
        key: 'f',
        name: 'Primary areas',
        description: 'Areas used for primary purposes such as industrial, office, residential or retail.'
      },
      {
        label: 'G',
        key: 'g',
        name: 'Secondary areas',
        description: 'Amenity and ancillary areas such as food court, delivery areas, car parking, etc'
      },
      {
        label: 'H',
        key: 'h',
        name: 'Other areas',
        description: 'Other areas'
      }
    ]
  }
}